// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import React from "react";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-16oxj4t-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);

/**
 * Indicates a completed step.
 *
 * @param {object} props - The component props
 * @param {string} [props.size] - The width/height of the icon as any CSS size unit
 * @param {string} [props.color] - The fill color of the icon as any CSS color value
 * @param {string} [props.title] - The title to add as a child of the root svg element
 *
 * @returns {React.ReactElement} - The CircleSelectedFilled component
 */
const CircleSelectedFilled = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm5.192-14.25a.997.997 0 00-.327.212l-7.452 7.196-2.187-2.701a1.007 1.007 0 00-1.412-.159l-.002.002a1.002 1.002 0 00-.141 1.415l2.82 3.481c.082.102.183.187.298.25a.997.997 0 001.25-.113L18.254 9.4l.002-.002a1.006 1.006 0 00.025-1.411l-.001-.001a.999.999 0 00-1.088-.237z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: " "
  })]
});
export default CircleSelectedFilled;